import React from 'react';
import ContactHeader from './ContactUsUtils/ContactHeader';
import ContactSections from './ContactUsUtils/ContactSections';
import KeyContacts from './ContactUsUtils/KeyContacts';
import './ContactUs.css';
import ContactBanner from './ContactUsUtils/ContactBanner';
import BottomSection from './ContactUsUtils/BottomSection';
import Footer from '../Footer/Footer';
import { useSelector } from 'react-redux';

const ContactUs = () => {

  
    const contactCopenhagen = useSelector((state) => state.ContactCopenhagen);

  return (
    <div style={{ background: '#fff' }}>
      <ContactBanner />
      <div className="contact-us-container">
        <ContactHeader place="COPENHAGEN" address1={contactCopenhagen?.visitingAddress} address2="Petersdalvej 1, DK-2770 Kastrup, Denmark" vat="DK32339026" />
        <ContactSections />
      </div>
      <div style={{marginTop:"40px", borderTop: "1px solid #E0E0E0"}}>
        <Footer/>
      </div>
    </div>
  );
};

export default ContactUs;
